import { useTranslation } from '@hooks/useTranslation';
import { Steps } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import logo_lealtad from "@assets/images/logo_lealtad.svg";
import card_lealtad from "@assets/images/card_lealtad.png";
import { useNavigate } from "react-router-dom";


function RedwardInformation({ user, ocultar = true }) {

    const { translate } = useTranslation();
    const navigate = useNavigate();

    const clase = (level)=>{
        if(level == 1) return 'amber'
        if(level == 2) return 'emerald'
        if(level == 3) return 'diamond'
        return '';
    }
    return (
        <div className="content-user">
            <div className="profile-info">
                <div className="ArtFans BlackIconPerfil ArtFansPerfil"></div>
                <div className="profile-details">
                    <h3>{user ? user.name + ' '+ (user.lastname ?? '') : translate('view.loading')}</h3>
                    {/* <span className="profile-link">{translate('view.profile')}</span> */}
                </div>
            </div>

            <div className="category-card">

                <div className="category-content">
                    <div className="img-category">
                        <img src={card_lealtad} alt="logo" />
                    </div>
                    <div className="logo-category">
                        <img src={logo_lealtad} alt="logo" />
                    </div>
                    <p className="category-title">{translate('view.myprofile.category')}</p>
                    <h2 className={clase(user?.loyalty?.level)}>{user?.loyalty?.level_name}</h2>
                    <p className="category-description">{user?.loyalty?.level ? (user?.loyalty?.crystals +' '+ translate('benefits.cristals')) : user?.loyalty?.description }</p>
                    <p className="affiliation-number">{translate('view.myprofile.affiliation_number')}: {user?.loyalty?.affiliation}</p>
                </div>

            </div>

            <div className="content-indicator">
                <div className="line-indicator">
                    <Steps current={user?.loyalty?.level}>
                    <Steps.Item title={`${translate('view.level')} Amber`} description={user?.loyalty?.level==1 ? user.loyalty.crystals +' '+ translate('benefits.cristals') : ''} />
                    <Steps.Item title={`${translate('view.level')} Emerald`} description={user?.loyalty?.level==2 ? user.loyalty.crystals +' '+ translate('benefits.cristals') : ''} />
                    <Steps.Item title={`${translate('view.level')} Diamond`} description={user?.loyalty?.level==3 ? user.loyalty.crystals +' '+ translate('benefits.cristals') : ''} />

                    </Steps>
                </div>
                {user?.loyalty?.level < 3 ? <div className="subtext">{translate('benefits.next')}: {user?.loyalty?.next_level}</div> : ''}
                {ocultar ? <a href="javascript:void(0)" onClick={() => navigate("/mi-perfil/mis-beneficios")} className="ButtonDark">{translate('benefits.redward')}</a> : ''}
            </div>
        </div>
    )
}

export default RedwardInformation
